<div *ngIf="curriculumDataReceived" class="outer-container">

  <div fxLayout="column" fxLayoutAlign="space-between">
    <!-- <div class="sub-title">Course Selection</div> -->
    <div class="reg-steps">

      <app-consumer-curriculum-registration-steps
      [whichStep]="2"
     >
     </app-consumer-curriculum-registration-steps>
    </div>
  </div>

  <div fxLayout="column" >
    
    <div class="jumpto">
      Jump to
    </div>
    
    <div class="grade-tabs" fxLayout="row wrap" fxLayoutAlign="space-evenly">

      <a
        *ngFor="let grade of curriculumData.Grades" 
        class="grade" 
        [routerLink]='"."'  
        [fragment]="grade.ConsumerGradeName.replace(' ', '')"
      >{{grade.ConsumerGradeName}}</a>

    </div>
  </div>



  <div *ngFor="let chosenGrade of curriculumData.Grades" class="body"> 

    <a [attr.id]="chosenGrade.ConsumerGradeName.replace(' ', '')"></a>

    <div class="gradeTitle">{{chosenGrade.ConsumerGradeName}}</div>

    <hr>

    <div fxLayout="row wrap">
      <div
      class="subject" 
      *ngFor="let subject of chosenGrade?.Subjects">
      

      <div  
        class="subject-header"
        fxLayout="row wrap"
        fxLayoutAlign="space-between center">

        <span>
          <b>{{subject.ConsumerSubjectName}}</b>
        </span>

      </div>


      <div class="curriculums" fxLayout="row wrap" fxLayoutAlign="start">

        <div 
          class="curriculum-card" 
          *ngFor="let curr of subject.Curriculums"
          (click)="redirectToCurriculumRegister(curr)">

            <div class="card-header" [ngStyle]="
              {
                'background': 'linear-gradient(180deg, rgba(0,0,0,45%) 0%, rgba(255, 255, 255, 0) 60%), 
                url(' + imagePath + curr.ImagePath + ')',
                'background-size': '100%'
              }">
              {{curr.CurriculumName}}
            </div>
        
        </div>
        
      </div> 

    </div>
    </div>
    

  </div>
  
</div>

<div *ngIf="!curriculumDataReceived" class="spinner-wrapper">
  <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
</div>
